import { InteractionStatus, InteractionRequiredAuthError } from '@azure/msal-browser';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';

import { loginRequest } from '../../authConfig';
import { DataKey } from '../../Store/callAPI/allAPIs';
import { removeAPIDataAction } from '../../Store/callAPI/actions';
import { toast } from 'react-toastify';

const useTrans = (tns) => {
    const { t } = useTranslation(tns);
    return t;
};

const useGetToken = () => {
    const { instance, accounts, inProgress } = useMsal();

    let token = '';
    if (inProgress === InteractionStatus.None && accounts.length > 0) {
        const tokenRequest = {
            account: accounts[0],
            scopes: loginRequest.scopes
        };

        // Acquire an access token
        instance
            .acquireTokenSilent(tokenRequest)
            .then((response) => {
                token = response.accessToken;
            })
            .catch(async (e) => {
                // Catch interaction_required errors and call interactive method to resolve
                if (e instanceof InteractionRequiredAuthError) {
                    await instance.acquireTokenRedirect(tokenRequest);
                }
                throw e;
            });
    }
    return token;
};

const tooglePassword = (id, iconID) => {
    var passwordInput = document.getElementById(id);
    var passwordIcon = document.getElementById(iconID);
    passwordInput.type === 'password' ? (passwordInput.type = 'text') : (passwordInput.type = 'password');
    passwordIcon.classList.toggle('ri-eye-off-line');
};
const percentage = (partialValue, totalValue) => {
    return (100 * partialValue) / totalValue;
};

const ShowErrMsg = (apiData, storekey) => {
    if (apiData?.[DataKey] && apiData?.[DataKey]?.statusCode) {
        let errMsg =
            apiData?.[DataKey]?.errorMessage?.length > 0
                ? apiData[DataKey]?.statusCode + ' error.' + apiData[DataKey]?.errorMessage[0]
                : apiData?.[DataKey]?.statusCode + ' error. Error in requesting data';
        toast.error(errMsg);
        removeAPIDataAction(storekey);
    }
};

const GetErrMsg = (apiData) => {
    let errMsg = apiData?.[DataKey]?.errorMessage?.length > 0 ? apiData[DataKey]?.errorMessage[0] : 'Error in fetching data';
    return errMsg;
};

const IsValidChromeVersion = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
        const version = userAgent.split('chrome/')[1].split(' ')[0];
        return parseInt(version) > 97;
    } else if (userAgent.includes('crios')) {
        const version = userAgent.split('crios/')[1].split(' ')[0];
        return parseInt(version) > 97;
    } else if (userAgent.includes('edg')) {
        const version = userAgent.split('edg/')[1].split(' ')[0];
        return parseInt(version) > 97;
    }
    return false;
};

export { useTrans, tooglePassword, useGetToken, percentage, ShowErrMsg, GetErrMsg, IsValidChromeVersion };
